
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CustomerTextPipe } from 'src/app/shared-module/pipes/customer-term.pipe';

@Component({
  selector: 'app-action-context-card',
  standalone: true,
  imports: [CustomerTextPipe],
  templateUrl: './action-context-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-context-card.component.scss'
})
export class ActionContextCardComponent {
  @Input() contextType: 'Audit' | 'Event' = 'Audit';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() body: string = '';
  @Input() meta: string = '';
}
